import { render } from "./NotificacoesVie.vue?vue&type=template&id=8e700932"
import script from "./NotificacoesVie.vue?vue&type=script&lang=js"
export * from "./NotificacoesVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__